export default __webpack_public_path__ + "static/media/agents-icon.b759dfd9.svg";